function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import url from "url";
import { API_HOST, FETCH_FAIL_ERROR_MESSAGE, GENERIC_ERROR_MESSAGE } from "../constants";
/**
 * @param {string} apiUrl
 * @param {object} fetchInit
 * @param {string} search
 * @param {boolean} noFormat Don't format apiUrl. Appropriate when apiUrl is already formatted.
 * @param {integer} timeoutMs Abort the request/response after timeoutMs milliseconds
 * @param {boolean} rawError Indicates if we should throw the raw Response object on unsuccessful requests
 *
 * @return {Promise<Response>}
 */ export function apiRequest(apiUrl) {
    return _apiRequest.apply(this, arguments);
}
function _apiRequest() {
    _apiRequest = _async_to_generator(function(apiUrl) {
        var fetchInit, search, noFormat, timeoutMs, rawError, _process_env, _process, storybookApiRequest, testUrl, testSearchParams, inTestMode, uri, init, controller, response, e, json;
        var _arguments = arguments;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    fetchInit = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {}, search = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : "", noFormat = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : false, timeoutMs = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : 0, rawError = _arguments.length > 5 && _arguments[5] !== void 0 ? _arguments[5] : false;
                    storybookApiRequest = false;
                    testUrl = apiUrl;
                    if (typeof process !== "undefined" && ((_process = process) === null || _process === void 0 ? void 0 : (_process_env = _process.env) === null || _process_env === void 0 ? void 0 : _process_env.STORYBOOK_HTTP_REQUESTS)) {
                        storybookApiRequest = true;
                        testSearchParams = new URLSearchParams(search).toString();
                        testUrl = testSearchParams ? "".concat(apiUrl, "?").concat(testSearchParams) : apiUrl;
                    }
                    inTestMode = noFormat || /^http/.test(apiUrl) || storybookApiRequest;
                    uri = inTestMode ? testUrl : url.format({
                        protocol: "https",
                        host: API_HOST,
                        pathname: apiUrl,
                        search: search
                    });
                    init = _object_spread_props(_object_spread({
                        method: "GET",
                        mode: "same-origin",
                        credentials: "same-origin"
                    }, fetchInit), {
                        headers: _object_spread({
                            "Document-Location-Href": document.location.href,
                            "X-Requested-With": "fetch"
                        }, fetchInit.headers)
                    });
                    if (timeoutMs) {
                        controller = new AbortController();
                        /* const timeoutId = */ setTimeout(function() {
                            return controller.abort();
                        }, timeoutMs);
                        init.signal = controller.signal;
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        fetch(uri, init)
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    // if fetch throws an error, it is most likely a network connection problem
                    // throw a nicer error message, otherwise this just says 'Failed to fetch'
                    // https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch#checking_that_the_fetch_was_successful
                    throw new Error(FETCH_FAIL_ERROR_MESSAGE);
                case 4:
                    if (!!response.ok) return [
                        3,
                        7
                    ];
                    if (rawError) {
                        throw response;
                    }
                    if (!/application\/json/.test(response.headers.get("Content-Type"))) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        response.json()
                    ];
                case 5:
                    json = _state.sent();
                    json.status = response.status;
                    json.statusText = response.statusText;
                    json.url = response.url;
                    // set error message to server error
                    if (!json.message) {
                        json.message = json.error;
                    }
                    // add generic error message if one was not set or 5xx response status
                    if (!json.message || response.status > 499 && response.status < 600) {
                        json.message = GENERIC_ERROR_MESSAGE;
                    }
                    throw json;
                case 6:
                    throw new Error(GENERIC_ERROR_MESSAGE);
                case 7:
                    return [
                        2,
                        response
                    ];
            }
        });
    });
    return _apiRequest.apply(this, arguments);
}
export default apiRequest;
